import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  // Brand colors are intentionally hardcoded (static) per GWC guidelines.
  // If brand updates are required in the future, update this palette + component overrides.
  primary: {
    main: '#3FAE2A',
    light: '#B8FBF0',
    dark: '#2B7E1F',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#00ABC7',
    // Keep additional shades derived to avoid breaking existing UI states.
    light: '#45C9D8',
    dark: '#007C8F',
    contrastText: '#ffffff',
  },
  error: {
    main: '#DC0C0C',
    light: '#FFECFC',
    dark: '#9D0F41',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f7b217',
    light: '#FFE082',
    dark: '#e65100',
    contrastText: '#ffffff',
  },
  info: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
    contrastText: '#ffffff',
  },
  success: {
    main: '#1b9e43',
    light: '#4caf50',
    dark: '#1b5e20',
    contrastText: '#ffffff',
  },
  grey: {
    50: '#F7F9FC',
    100: '#EFF3F6',
    200: '#DBE2E9',
    300: '#B5B5B5',
    400: '#B5B5B5',
    500: '#555555',
    600: '#555555',
    700: '#424242',
    800: '#2B2B2B',
    900: '#212121',
  },
  background: {
    default: '#F7F9FC',
    paper: '#ffffff',
  },
  text: {
    primary: '#141F2B',
    secondary: '#555555',
    disabled: '#B5B5B5',
  },
  divider: '#B5B5B5',
};

export default palette;